import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { Add } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";
import { SnackAlertContext } from "../../../../context/SnackAlertContext";
import { AuthContext } from "../../../../context/AuthContext";
import CreateEmployeeForCompanyDialog from "../../Customers/CreateEmployeeForCompanyDialog";
import useShopEmployees from "../../../../hooks/useShopEmployees";

const filter = createFilterOptions();

const SelectMultipleShopEmployees = ({
  companyId,
  excludeUserIds,
  value,
  label = "User",
  onUpdate,
  disabled,
  enableAdd,
  onBlur,
  error,
  helperText,
  required,
  ...props
}) => {
  const { authToken } = useContext(AuthContext);
  const theme = useTheme();

  const { shopEmployees, loading, hasLoaded } = useShopEmployees(authToken);

  if (hasLoaded)
    return (
      <>
        <Autocomplete
          multiple
          freeSolo
          selectOnFocus
          clearOnBlur
          value={value}
          disabled={disabled}
          handleHomeEndKeys
          onChange={(event, newValue) => {
            if (onUpdate) onUpdate(newValue ?? null);
          }}
          onInputChange={() => {
            // console.log("onInputChange");
          }}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);

            if (enableAdd && params.inputValue !== "") {
              filtered.push({
                id: undefined,
                fullName: params.inputValue,
              });
            }

            return filtered;
          }}
          options={shopEmployees}
          getOptionLabel={(option) => {
            //   console.log("Option", option);
            // for example value selected with enter, right from the input
            if (typeof option === "string") {
              return option;
            }
            if (option.inputValue) {
              return option.inputValue;
            }

            // If we're passing in empty object with only the user id, then return the equivalent name from the list
            if (!option.fullName && option.id) {
              let employee = shopEmployees.find(
                (employee) => employee.id == option.id
              );
              if (employee) return employee.fullName;
              else return null;
            }
            return option.fullName;
          }}
          isOptionEqualToValue={(option, value) => {
            //  The "selected" prop on renderOption depends on this
            if (!value) return false;
            return value.id == option.id;
          }}
          renderOption={(props, option, { selected }) => {
            const { key, ...optionProps } = props;

            if (option.id)
              return (
                <li key={key} {...optionProps}>
                  {option.fullName}
                </li>
              );
            else
              return (
                <li key={key} {...optionProps}>
                  <Add style={{ marginRight: 8 }} />

                  {option.id ? option.fullName : `Add "${option.fullName}"`}
                </li>
              );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size={props.size ? props.size : "small"}
              label={label}
              sx={{
                width: "100%",
              }}
              variant="outlined" // filled, outlined, standard
              InputProps={{
                ...params.InputProps,
                onKeyDown: (e) => {
                  if (!enableAdd && e.key === "Enter") {
                    e.stopPropagation();
                  }
                },
                endAdornment: <>{params.InputProps.endAdornment}</>,
              }}
              onBlur={onBlur}
              error={error}
              helperText={helperText}
              required={required}
            />
          )}
        />
      </>
    );
};

export default SelectMultipleShopEmployees;
